module.exports = __webpack_public_path__ + "img/ico-alarm.183e8d51.svg";